import { observer } from 'mobx-react-lite';
import { usePluginStore } from '../../store/RootStoreContext';
import CallApp from './CallApp';

const CallAppContainer = (): JSX.Element => {
    const { callPlugin } = usePluginStore();

    return callPlugin ? <CallApp pluginId={callPlugin.pluginId} key={callPlugin.pluginId} /> : null;
};

export default observer(CallAppContainer);
